import { render, staticRenderFns } from "./kdxPageComponent.g.vue?vue&type=template&id=b8770776&scoped=true"
import script from "./kdxPageComponent.g.vue?vue&type=script&lang=js"
export * from "./kdxPageComponent.g.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8770776",
  null
  
)

export default component.exports